/**
 * Stats card component for displaying a single metric.
 */

interface StatsCardProps {
  label: string;
  value: string | number;
  subtitle?: string;
  variant?: "default" | "success" | "warning" | "accent";
}

export function StatsCard({
  label,
  value,
  subtitle,
  variant = "default",
}: StatsCardProps) {
  const variantStyles = {
    default: "bg-slate-50 border-slate-200",
    success: "bg-green-50 border-green-200",
    warning: "bg-amber-50 border-amber-200",
    accent: "bg-blue-50 border-blue-200",
  };

  const valueStyles = {
    default: "text-slate-900",
    success: "text-green-700",
    warning: "text-amber-700",
    accent: "text-blue-700",
  };

  return (
    <div
      className={`flex-1 p-3 rounded-xl border ${variantStyles[variant]}`}
    >
      <p className="text-[10px] uppercase tracking-wide text-slate-500 mb-1">
        {label}
      </p>
      <p className={`text-xl font-bold ${valueStyles[variant]}`}>{value}</p>
      {subtitle && (
        <p className="text-[11px] text-slate-500 mt-0.5">{subtitle}</p>
      )}
    </div>
  );
}
